import {
  lockAsync,
  OrientationLock,
  supportsOrientationLockAsync,
} from 'expo-screen-orientation';
import { isWeb } from 'shared/constants/platform';

export const lockMobileToPortraitIfPossible = async () => {
  if (
    !isWeb &&
    (await supportsOrientationLockAsync(OrientationLock.PORTRAIT_UP))
  ) {
    await lockAsync(OrientationLock.PORTRAIT_UP);
  }
};

export const lockMobileToLandscapeIfPossible = async () => {
  if (
    !isWeb &&
    (await supportsOrientationLockAsync(OrientationLock.LANDSCAPE))
  ) {
    await lockAsync(OrientationLock.LANDSCAPE);
  }
};
